module.exports = __webpack_public_path__ + "img/home.c147a935.jpeg";